import { InvalidFieldError } from '../errors';
export class NumberFieldValidation {
    constructor(field) {
        this.field = field;
    }
    // Validate that the fielf is number
    validate(input) {
        return !input[this.field] || String(input[this.field]).match(/^[0-9]+$/) ? null : new InvalidFieldError();
    }
}
